
import './UnityUnit.css'
import { GetExteriorImage, GetFloorImage } from '../UnityFirebaseCalls/FirebaseGetImage'
import { Carousel } from 'react-responsive-carousel';
import { onUnityUpdateMessage } from '../UnityLogic/ReceiveMessage';

export function UnityUnit(thisUnit, floorPlanInfo){

    //units have a name
    // an id
    // an image
    // a floor plan    
    GetExteriorImage(thisUnit.id, "unitExterior" + thisUnit.id);
    
    return(
        <div>
            <h1>{thisUnit.name}</h1>
            <button onClick={()=>{
                    console.log("This Unit Information ", thisUnit);
                    onUnityUpdateMessage.currentUnit = thisUnit;
                    onUnityUpdateMessage.goToUnit(thisUnit.id);
                    onUnityUpdateMessage.getUnitRooms(thisUnit.id);
                }}>Enter Unit</button>
            <img id={"unitExterior" + thisUnit.id} alt="exterior"></img>
            <h2>Floor Plans</h2>

            <Carousel
                autoPlay={false}
                showArrows={false}
                renderIndicator={false}
                centerMode={true}
                swipeable={false}
                showStatus={false}
                emulateTouch={true}
                infiniteLoop={false}
                showIndicators={true}
                showThumbs={true}
            >
                {floorPlanInfo.unit[thisUnit.id].map((floorPlanName)=>{

                    return(<img src={floorPlanInfo.unitURLs[thisUnit.id][floorPlanName]} alt="floorPlan"></img>)

                })}
            </Carousel>
        </div>
        )
}


// populateUnits(unitJson, parentToAppend, parentList){
//     //for testing for now
//     console.log("GOT UNITS");

//     this.clearThisUI(parentList);
    
//     this.lastUnitSetJson = unitJson;

//     unitJson.forEach((unit)=>{
//         // var unitButton = document.createElement('button');
//         // unitButton.innerHTML = unit.name;

//         // parentToAppend.append(unitButton);

//         // unitButton.onclick = () =>{
//         // 	this.getUnitRooms(unit.id);
//         // 	this.goToUnit(unit.id);
//         // 	this.currentUnitId = unit.id;
//         // }

//         // parentList.push(unitButton);

//         this.createUnitUI(unit.id, unit, parentToAppend, parentList);
//     });

//     this.addGoBackButton();

//     //this.currentUiState = "inUnit";
//     //this.currentUiState = "inCategory";
//     if(parentToAppend === this.leftUiHolder){
//         this.leftUiTitle.innerHTML = "Units";
//     }
//     else if(parentToAppend === this.rightUiHolder){
//         this.rightUiTitle.innerHTML = "Units";
//     }
// }